// eslint-disable-next-line import-x/no-mutable-exports
let jQueryInstance;

if (!jQueryInstance) {
  // eslint-disable-next-line no-undef
  jQueryInstance = require('jquery');

  window.jQuery = jQueryInstance;
  window.$ = jQueryInstance;
  window.jquery = jQueryInstance;
}

export default jQueryInstance;
